class AuthStore {

  getToken(): string | null {
    return localStorage.getItem("token");
  }

  /**
   * Token to send on an API call. The usermgmt web component owns the Keycloak session and
   * exposes window.getFreshToken(), which refreshes the token if it expires within 30 sec.
   * Returns null when the session can no longer be refreshed (idle past SSO session timeout).
   */
  async getFreshToken(): Promise<string | null> {
    const provider = (window as any).getFreshToken;
    if (typeof provider !== "function") {
      // Web component not initialised yet: fall back to the stored token
      return this.getToken();
    }
    try {
      return await provider();
    } catch {
      return null;
    }
  }

  setIsLoggedIn(isLoggedIn: boolean) {
    localStorage.setItem("loggedIn", JSON.stringify(isLoggedIn));
  }

  getIsLoggedIn(): boolean {
    const loggedIn = localStorage.getItem("loggedIn");
    return loggedIn ? JSON.parse(loggedIn) : false;
  }

  setToken(token: string) {
    localStorage.setItem("token", token);
  }

  clear() {
    localStorage.clear();
    sessionStorage.clear();
  }
}

export const authStore = new AuthStore();
